export * from './layout';
export * from './notification';
export * from './building';
export * from './cloud';
export * from './tree';
export * from './search';
export * from './auth-redirect';

import { LayoutComponents } from './layout';
import { NotificationComponents } from './notification';
import { BuildingComponents } from './building';
import { CloudComponents } from './cloud';
import { TreeComponents } from './tree';
import { SearchComponents } from './search';
import { AuthRedirectComponent } from './auth-redirect';

export const Components = [
    ...LayoutComponents,
    ...NotificationComponents,
    ...BuildingComponents,
    ...CloudComponents,
    ...TreeComponents,
    ...SearchComponents    
];

export const BootstrapComponents = [
    AuthRedirectComponent
];